// Diagnosis runs only in english for the moment: It has to be independant
var Diagnosis = new (class {

  constructor() {

    /* -------------- */
    /* WORDING */

    this._steps = {
      "default"           : "...",
      "script-initialized": "The script looks ok",
      "init-function"     : "The initialization process is starting",
      "identify-function" : "I see you provide info about your contacts",
      "widget-initialized": "Your public key is correct",
      "append-to-dom"     : "Chatbox components ready",
      "guest-initialized" : "You have been identified as {{name}}"
    };

    this._warns = {
      "identify-mandatory-attributes": `One or both of the mandatory attributes "id" and "name" are missing, your contacts won't be identified`,
      "disabled-when-offline"        : `You are in "delayed" mode and your chatbox is configured to be hidden in that case`
    };

    // Most errors come from the server
    this._errors = {
      "default": "An unknown error occured"
    };

    this._welcomeMessage            = "Hello! Let's see if your chatbox works correctly";
    this._successMessage            = "Alright! The chatbox was well deployed! You're the best!";
    this._successWithWarningMessage = "You might want to check the orange lines above."

    /* -------------- */

    this._cdnUrl = null;

    this._window = Utils.hasClass(document.body, 'slaask-iframe')
                  ? window.parent
                  : window;

    const urlParameters = Utils.getUrlParamsWithRegex(this._window.location.search, /(xeno|slaask|sarbacane)diagnosis/g);
    const parameters = Object.keys(urlParameters);

    this._enabled = (parameters.length > 0);

    if (this._enabled) {
      const brandsColor = {
        xeno: "#27c469",
        slaask: "#e01765",
        sarbacane: "#e94f3d"
      };

      this._state = "pending";
      this._brandColor = brandsColor[parameters[0].split("diagnosis")[0]];
      this._lastType = null;
      this._queue = [];
      this._warnHistory = [];
    }
  }

  get enabled() { return this._enabled; }

  init(cdnUrl) {
    this._cdnUrl = cdnUrl;
    if (this._enabled) {
      this._displayBox();
      this.welcome();
    }
  }

  // Same as getCssUrl in Dom.js
  _getCssUrl(fileName) {
    return this._cdnUrl + "/chat/css/" + fileName + ".min.css";
  }

  async _displayBox() {
    if (this.enabled) {
      let css = `GULP-CSS-FILE-DIAGNOSIS`;
      if (`GULP-CSS-EXTERNAL`) await Utils.loadCssFile(this._window.document, this._getCssUrl('diagnosis'));
      else await Utils.appendCss(this._window.document, css);
      // Don't use anything other than divs to prevent global css rules to be applied
      let html = `
        <style>
          ${css}
        </style>
        <div id="asktech-diagnosis-container" class="asktech-diagnosis-container">
          <div class="asktech-diagnosis-avatar">
            ${this._svg(this._state, this._brandColor)}
          </div>
          <div class="asktech-diagnosis-bubble"></div>
        </div>
      `;
      this._window.document.body.insertAdjacentHTML('beforeend', html);
      Utils.eventHappened('diagnosis-ready');
    }
  }

  _addMessage(str, type) {
    if (this.enabled && str) {
      let lastType = this._lastType;
      let handler = () => {
        let bubble = this._window.document.querySelector('#asktech-diagnosis-container .asktech-diagnosis-bubble');
        let line = `<div class="asktech-diagnosis-line-${type}">${str}</div>`;

        if (this._isStep(type) && !this._isStep(lastType)) bubble.innerHTML += `<div class="asktech-diagnosis-block"></div>`;

        if (this._isStep(type)) bubble.querySelector(".asktech-diagnosis-block").innerHTML += line;
        else bubble.innerHTML += line;
      };
      if (type == 'welcome') Utils.event('diagnosis-ready').then(handler);
      else this._queueMessage(handler);
      this._lastType = type;
    }
  }

  _isStep(type) {
    return type == "step" || type == "warn";
  }

  // The queue brings a nicer display by adding delay between lines
  async _queueMessage(handler, timer) {
    let queueEmpty = this._queue.length == 0;
    this._queue.push({
      handler: handler,
      timer: timer
    });
    if (queueEmpty) {
      await Promise.all([
        Utils.event('diagnosis-start'),
        Utils.event('diagnosis-ready')
      ]);
      while (this._queue.length) {
        this._queue[0].handler();
        await Utils.delay(this._queue[0].timer);
        this._queue.shift();
      }
    }
  }

  async startIn(delay) {
    if (this.enabled) {
      await Utils.delay(delay);
      Utils.eventHappened('diagnosis-start');
    }
  }

  async welcome() {
    if (this._state == "pending") {
      let message = this._welcomeMessage + " " + this._emoji("simple_smile");
      this._addMessage(message, "welcome");
    }
  }

  step(stepCode, variables) {
    if (this._state == "pending") {
      let message = stepCode
                    ? this._steps[stepCode]
                      ? this._steps[stepCode]
                      : stepCode
                    : this._steps["default"];
      message = this._replace(message, variables);
      this._addMessage(message, "step");
    }
  }

  warn(warnCode, variables) {
    if (this._state == "pending") {
      let message = warnCode
                    ? this._warns[warnCode]
                      ? this._warns[warnCode]
                      : warnCode
                    : null;
      message = this._replace(message, variables);
      this._addMessage(message, "warn");
      this._warnHistory.push(message);
    }
  }

  error(errorCode, variables) {
    if (this._state == "pending") {
      this._state = "error";
      let message = this._errors["default"];
      if (errorCode) {
        if (errorCode.message) message = errorCode.message;
        else if (this._errors[errorCode]) message = this._errors[errorCode];
        else message = errorCode;

        if (errorCode.code) this._sendToOpener(errorCode.code, message);
      }
      message = this._svg("attention", "#ec5555") + " " + this._replace(message, variables);
      this._addMessage(message, "error");
      this._displayFace("error");
    }
  }

  success() {
    if (this._state == "pending") {
      this._state = "success";
      let message = this._successMessage + " " + this._emoji("+1");
      this._addMessage(message, "success");
      if (this._hadWarning) {
        this._addMessage(this._successWithWarningMessage, "final-warning");
        this._sendToOpener("warn", this._warnHistory.join("<br/>"));
      }
      else this._sendToOpener("success", message);
      this._displayFace("success");
    }
  }

  _replace(msg, variables) {
    if (typeof msg == "string") {
      Utils.forEach(variables, (value, key) => {
        let regex = new RegExp("{{" + key + "}}", "g");
        msg = msg.replace(regex, value);
      });
      return msg;
    }
    else return msg;
  }

  _emoji(emoji) {
    return `<div class="asktech-diagnosis-emoji" style="background-image: url('${this._cdnUrl}/emoji/${emoji}.png')"></div>`;
  }

  _sendToOpener(code, fallbackMessage) {
    if (window.top.opener) {
      window.top.opener.postMessage({
        'action': 'diagnosis',
        'code': code,
        'message': fallbackMessage
      }, "*");
    }
  }

  get _hadWarning() {
    return this._warnHistory.length > 0;
  }

  _displayFace(faceName) {
    if (this._enabled) {
      let avatarContainer = this._window.document.querySelector("#asktech-diagnosis-container .asktech-diagnosis-avatar");
      avatarContainer.innerHTML = this._svg(faceName, this._brandColor);
      if (faceName == "success") avatarContainer.className += " asktech-diagnosis-animation-happy";
      if (faceName == "error") avatarContainer.className += " asktech-diagnosis-animation-sad";
    }
  }

  _svg(image, color) {
    switch(image) {
      case "pending":
        return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 69.13 69.13"><defs><style>.cls-1{fill:${color};}.cls-2{fill:#fff;}.cls-3{fill:#f0f3fa;}.cls-4{fill:${color};}.cls-5{fill:${color};}</style></defs><title>ic Default</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><circle class="cls-1" cx="34.56" cy="34.56" r="34.56"/><path class="cls-2" d="M56.69,27.6h-.86A20.46,20.46,0,0,0,38.6,14.66V14a1.12,1.12,0,0,0-1.13-1.13H35.06V9.8a2.64,2.64,0,1,0-1,0v3.1h-2.4A1.13,1.13,0,0,0,30.52,14v.63c-9.76.91-17.85,8.66-18.42,18.61,0,.42,0,.86,0,1.29s0,.87,0,1.3c.6,10.6,9.75,18.7,20.37,18.7h4.19c10.11,0,18.88-7.36,20.21-17.22h0a3.25,3.25,0,0,0,3.07-3.24V30.85A3.26,3.26,0,0,0,56.69,27.6Z"/><path class="cls-3" d="M14.6,35.86c0-.43,0-.86,0-1.3s0-.87,0-1.29A20,20,0,0,1,30.52,15.06v0a1.14,1.14,0,0,0,1.14,1.14h.65a1.14,1.14,0,0,1-1.13-1.14v-.17A20.63,20.63,0,0,1,35,14.56h-2.5c-.44,0-.86,0-1.29,0V14a1.13,1.13,0,0,1,1.13-1.13h-.65A1.13,1.13,0,0,0,30.52,14v.63A20.48,20.48,0,0,0,13.29,27.6h-.85a3.25,3.25,0,0,0-3.25,3.25V34.1a3.25,3.25,0,0,0,3.07,3.24c1.33,9.86,10.09,17.22,20.21,17.22H35C24.35,54.56,15.2,46.46,14.6,35.86Z"/><rect class="cls-3" x="16.98" y="25.81" width="35.17" height="13.33" rx="6.67" ry="6.67"/><circle class="cls-4" cx="26.54" cy="33" r="2.65"/><circle class="cls-4" cx="42.58" cy="33" r="2.65"/><path class="cls-5" d="M34.56,48a5.93,5.93,0,0,1-5.41-3.52A1,1,0,0,1,31,43.65a3.92,3.92,0,0,0,7.17,0,1,1,0,0,1,1.32-.51A1,1,0,0,1,40,44.46,5.94,5.94,0,0,1,34.56,48Z"/><path class="cls-2" d="M34.56,69.13a34.39,34.39,0,0,0,17.58-4.81,6.67,6.67,0,0,0-6.66-6.47H23.65A6.66,6.66,0,0,0,17,64.32,34.36,34.36,0,0,0,34.56,69.13Z"/><path class="cls-3" d="M17,64.32c.66.39,1.33.76,2,1.1v-.9h0a6.67,6.67,0,0,1,6.67-6.67h-2A6.66,6.66,0,0,0,17,64.32Z"/><path class="cls-3" d="M32.67,7.21A2.64,2.64,0,0,1,34.94,4.6a2.45,2.45,0,0,0-.38,0,2.65,2.65,0,0,0,0,5.29c.13,0,.25,0,.38,0A2.65,2.65,0,0,1,32.67,7.21Z"/></g></g></svg>`;
        break;
      case "error":
        return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 69.13 69.13"><defs><style>.cls-1{fill:${color};}.cls-2{fill:#fff;}.cls-3{fill:#f0f3fa;}.cls-4{fill:${color};}</style></defs><title>ic Weary</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><circle class="cls-1" cx="34.56" cy="34.56" r="34.56"/><path class="cls-2" d="M56.69,27.6h-.86A20.46,20.46,0,0,0,38.6,14.66V14a1.12,1.12,0,0,0-1.13-1.13H31.66A1.13,1.13,0,0,0,30.52,14v.63c-9.76.91-17.85,8.66-18.42,18.61,0,.42,0,.86,0,1.29s0,.87,0,1.3c.6,10.6,9.75,18.7,20.37,18.7h4.19c10.11,0,18.88-7.36,20.21-17.22h0a3.25,3.25,0,0,0,3.07-3.24V30.85A3.26,3.26,0,0,0,56.69,27.6Z"/><path class="cls-2" d="M34.06,9.8v3.1h1V9.8a2.64,2.64,0,1,0-1,0Z"/><path class="cls-3" d="M14.6,35.86c0-.43,0-.86,0-1.3s0-.87,0-1.29A20,20,0,0,1,30.52,15.06v0a1.14,1.14,0,0,0,1.14,1.14h.65a1.14,1.14,0,0,1-1.13-1.14v-.17A20.63,20.63,0,0,1,35,14.56h-2.5c-.44,0-.86,0-1.29,0V14a1.13,1.13,0,0,1,1.13-1.13h-.65A1.13,1.13,0,0,0,30.52,14v.63A20.48,20.48,0,0,0,13.29,27.6h-.85a3.25,3.25,0,0,0-3.25,3.25V34.1a3.25,3.25,0,0,0,3.07,3.24c1.33,9.86,10.09,17.22,20.21,17.22H35C24.35,54.56,15.2,46.46,14.6,35.86Z"/><rect class="cls-3" x="16.98" y="25.81" width="35.17" height="13.33" rx="6.67" ry="6.67"/><path class="cls-2" d="M34.56,69.13a34.39,34.39,0,0,0,17.58-4.81,6.67,6.67,0,0,0-6.66-6.47H23.65A6.66,6.66,0,0,0,17,64.32,34.36,34.36,0,0,0,34.56,69.13Z"/><path class="cls-3" d="M17,64.32c.66.39,1.33.76,2,1.1v-.9h0a6.67,6.67,0,0,1,6.67-6.67h-2A6.66,6.66,0,0,0,17,64.32Z"/><path class="cls-3" d="M32.67,7.21A2.64,2.64,0,0,1,34.94,4.6a2.45,2.45,0,0,0-.38,0,2.65,2.65,0,0,0,0,5.29c.13,0,.25,0,.38,0A2.65,2.65,0,0,1,32.67,7.21Z"/><path class="cls-4" d="M23.74,28.21a.7.7,0,0,1,0-1.4c2.24,0,5.3-1.41,6.13-3.41a.7.7,0,0,1,1.3.54c-1.1,2.62-4.7,4.26-7.42,4.27Z"/><path class="cls-4" d="M45.39,28.21h0c-2.72,0-6.33-1.65-7.42-4.27a.7.7,0,1,1,1.29-.54c.84,2,3.9,3.4,6.13,3.41a.7.7,0,1,1,0,1.4Z"/><path class="cls-4" d="M24.06,34.3a12.56,12.56,0,0,1-2.12-.19,1,1,0,0,1,.36-2c3.51.63,7-.66,7.35-2.75a1,1,0,0,1,2,.37C31,32.78,27.57,34.3,24.06,34.3Z"/><path class="cls-4" d="M45.07,34.3c-3.52,0-7-1.52-7.56-4.54a1,1,0,1,1,2-.37c.4,2.09,3.84,3.38,7.36,2.75a1,1,0,0,1,.35,2A12.36,12.36,0,0,1,45.07,34.3Z"/><path class="cls-4" d="M24.45,48.22c0-3,4.53-7.27,10.11-7.27s10.11,4.3,10.11,7.27-4.52.66-10.11.66S24.45,51.2,24.45,48.22Z"/><path class="cls-2" d="M34.56,41.93a9.27,9.27,0,0,0-5.37,1.76.33.33,0,0,0,.19.59H39.74a.33.33,0,0,0,.2-.59A9.28,9.28,0,0,0,34.56,41.93Z"/></g></g></svg>`;
        break;
      case "success":
        return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 69.13 69.13"><defs><style>.cls-1{fill:${color};}.cls-2{fill:#fff;}.cls-3{fill:#f0f3fa;}.cls-4{fill:${color};}.cls-5{fill:#fce2e9;}</style></defs><title>ic Relaxed</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><circle class="cls-1" cx="34.56" cy="34.56" r="34.56"/><path class="cls-2" d="M56.69,27.6h-.86A20.46,20.46,0,0,0,38.6,14.66V14a1.12,1.12,0,0,0-1.13-1.13H31.66A1.13,1.13,0,0,0,30.52,14v.63c-9.76.91-17.85,8.66-18.42,18.61,0,.42,0,.86,0,1.29s0,.87,0,1.3c.6,10.6,9.75,18.7,20.37,18.7h4.19c10.11,0,18.88-7.36,20.21-17.22h0a3.25,3.25,0,0,0,3.07-3.24V30.85A3.26,3.26,0,0,0,56.69,27.6Z"/><path class="cls-2" d="M34.06,9.8v3.1h1V9.8a2.64,2.64,0,1,0-1,0Z"/><path class="cls-3" d="M14.6,35.86c0-.43,0-.86,0-1.3s0-.87,0-1.29A20,20,0,0,1,30.52,15.06v0a1.14,1.14,0,0,0,1.14,1.14h.65a1.14,1.14,0,0,1-1.13-1.14v-.17A20.63,20.63,0,0,1,35,14.56h-2.5c-.44,0-.86,0-1.29,0V14a1.13,1.13,0,0,1,1.13-1.13h-.65A1.13,1.13,0,0,0,30.52,14v.63A20.48,20.48,0,0,0,13.29,27.6h-.85a3.25,3.25,0,0,0-3.25,3.25V34.1a3.25,3.25,0,0,0,3.07,3.24c1.33,9.86,10.09,17.22,20.21,17.22H35C24.35,54.56,15.2,46.46,14.6,35.86Z"/><rect class="cls-3" x="16.98" y="25.81" width="35.17" height="13.33" rx="6.67" ry="6.67"/><path class="cls-2" d="M34.56,69.13a34.39,34.39,0,0,0,17.58-4.81,6.67,6.67,0,0,0-6.66-6.47H23.65A6.66,6.66,0,0,0,17,64.32,34.36,34.36,0,0,0,34.56,69.13Z"/><path class="cls-3" d="M17,64.32c.66.39,1.33.76,2,1.1v-.9h0a6.67,6.67,0,0,1,6.67-6.67h-2A6.66,6.66,0,0,0,17,64.32Z"/><path class="cls-3" d="M32.67,7.21A2.64,2.64,0,0,1,34.94,4.6a2.45,2.45,0,0,0-.38,0,2.65,2.65,0,0,0,0,5.29c.13,0,.25,0,.38,0A2.65,2.65,0,0,1,32.67,7.21Z"/><path class="cls-4" d="M48,27.64a.69.69,0,0,1-.47-.18c-1.08-1-3-1-5-.94l-1.26,0a.71.71,0,0,1-.7-.71.69.69,0,0,1,.7-.69.74.74,0,0,1,.15,0l1.08,0c2.23,0,4.53-.07,6,1.31a.7.7,0,0,1,0,1A.67.67,0,0,1,48,27.64Z"/><path class="cls-4" d="M21.13,27.64a.7.7,0,0,1-.47-1.21c1.48-1.38,3.78-1.34,6-1.31l1.23,0h0a.7.7,0,1,1,0,1.4l-1.26,0c-2,0-4-.06-5,.94A.7.7,0,0,1,21.13,27.64Z"/><path class="cls-4" d="M40.08,44.65c0,1.62-2.47,2.78-5.52,2.78S29,46.27,29,44.65s2.47.09,5.52.09S40.08,43,40.08,44.65Z"/><circle class="cls-5" cx="49.73" cy="37.56" r="4.25"/><circle class="cls-5" cx="19.4" cy="37.56" r="4.25"/><path class="cls-4" d="M47,35a1,1,0,0,1-.86-.5,4.15,4.15,0,0,0-2.54-1.9,4,4,0,0,0-3.06.45,1,1,0,1,1-1-1.71,6,6,0,0,1,4.59-.68,6.17,6.17,0,0,1,3.78,2.84,1,1,0,0,1-.36,1.36A1,1,0,0,1,47,35Z"/><path class="cls-4" d="M22.11,35a.93.93,0,0,1-.5-.14,1,1,0,0,1-.36-1.36A6.15,6.15,0,0,1,25,30.66a6,6,0,0,1,4.59.68,1,1,0,1,1-1,1.71,4,4,0,0,0-3.07-.45A4.13,4.13,0,0,0,23,34.5,1,1,0,0,1,22.11,35Z"/></g></g></svg>`;
        break;
      case "attention":
        return `<svg style="color: ${color};" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="exclamation-triangle" class="svg-inline--fa fa-exclamation-triangle fa-w-18" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"></path></svg>`;
        break;
    }
  }

});
